import styled from "styled-components"

export const Form = styled.form`
    margin: 0;
    padding: 0;
    font-family: ${p => p.theme.fontFamily.rubik};
`
